module.exports = __webpack_public_path__ + "img/jumbopack-active.46286ef5.svg";